'use strict';

export default function () {
    return {
        restrict: 'A',
        template: require('../view/metric-filter-indicator.html'),
        controller: [
            '$scope', 'OperatorService', 'DashboardFiltersService',
            function ($scope, OperatorService, DashboardFiltersService) {
                $scope.getOperatorDisplayName = OperatorService.getDisplayName;
                $scope.isBetween = OperatorService.isBetween;
                $scope.filters = DashboardFiltersService.getSidebarFilters();

                $scope.$watch(
                    () => DashboardFiltersService.getSidebarFilters(),
                    () => $scope.filters = DashboardFiltersService.getSidebarFilters(),
                    true,
                );
            },
        ],
    };
}
